var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 16H34C25.7157 16 19 22.7157 19 31V108C19 116.284 25.7157 123 34 123H97",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 66C45.7909 66 44 67.7909 44 70C44 72.2091 45.7909 74 48 74L48 66ZM129.828 72.8284C131.391 71.2663 131.391 68.7337 129.828 67.1716L104.373 41.7157C102.81 40.1536 100.278 40.1536 98.7157 41.7157C97.1536 43.2778 97.1536 45.8105 98.7157 47.3726L121.343 70L98.7157 92.6274C97.1536 94.1895 97.1536 96.7222 98.7157 98.2843C100.278 99.8464 102.81 99.8464 104.373 98.2843L129.828 72.8284ZM48 74L127 74L127 66L48 66L48 74Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.5b9b641b90012b1192056a8c7e1b8c45.svg";
export { ForwardRef as ReactComponent };